import {  Model} from "@datx/core";
import { jsonapi } from "@datx/jsonapi";

export default class CountDashboardData extends jsonapi(Model) {
  static type = "countDashboardData";

}
